import { BaseDto } from "@/shared/dtos/base-dto";

export class respuestas extends BaseDto {
  public nombre!: string;
  public puntuacion!: number;
  public id_pregunta!: number;
}
